export const APPLICATION_LIST_GET = 'APPLICATION_LIST_GET'
export const APPLICATION_LIST_GET_LOAD = 'APPLICATION_LIST_GET_LOAD'
export const APPLICATION_LIST_GET_SUCCESS = 'APPLICATION_LIST_GET_SUCCESS'
export const APPLICATION_LIST_GET_FAILED = 'APPLICATION_LIST_GET_FAILED'
export const APPLICATION_LIST_GET_CLEAR = 'APPLICATION_LIST_GET_CLEAR'
